import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';

const RiskSelector = ({ onSelectRiskLevel }) => {
  const [selectedRisk, setSelectedRisk] = useState('');
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const riskLevels = [
    { label: "Light", value: "LIGHT", color: "#2E8B57" },
    // { label: "Moderate", value: "MODERATE", color: "#FFFF00" },
    { label: "Severe", value: "SEVERE", color: "#FFFF00" },
    { label: "Lightning", value: "Lightnig_Binary", color: "#FFA500" },
    { label: "High-density lightning", value: "Lightnig_Binary_P2", color: "#FF4500" },
    { label: "Overshoot", value: "OT", color: "#b4ace6" }
  ];

  // const handleRiskLevelClick = (value) => {
  //   if (selectedRisk === value) {
  //     setSelectedRisk('');
  //     onSelectRiskLevel('');
  //   } else {
  //     setSelectedRisk(value);
  //     onSelectRiskLevel(value);
  //   }
  // };
  // Efecto para controlar la visibilidad del Tooltip
  useEffect(() => {
      const timer = setTimeout(() => {
      setTooltipOpen(false); // Oculta el Tooltip después de 5 segundos
      }, 5000);

      return () => clearTimeout(timer); // Limpieza al desmontar
  }, []); 

  return (
    <Box
      className="risk-levels-legend"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& > div': {
          m: 0,
          '&:first-of-type': {
            borderTopLeftRadius: '40px',
            borderBottomLeftRadius: '40px',
          },
          '&:last-of-type': {
            borderTopRightRadius: '40px',
            borderBottomRightRadius: '40px',
          }
        },
      }}
    >
      {riskLevels.map((level, index) => (
        <Tooltip key={level.label} title="SELECT SEVERITY" TransitionComponent={Zoom} arrow open={index === 0 ? tooltipOpen : false}>
          <Box
            sx={{
              backgroundColor: selectedRisk && selectedRisk !== level.value ? 'rgba(117, 117, 117, 0.2)' : level.color,
              color: selectedRisk && selectedRisk !== level.value ? 'rgba(117, 117, 117, 1)' : 'rgba(0, 0, 0, 1)', // Hace que el texto también parezca apagado si no es el seleccionado
              padding: '0px 10px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '20px',
              //cursor: 'auto', estaba en pointer
              borderRadius: '4px',
              border: '1.15px solid transparent',
              '&:hover': {
                opacity: 1, //estaba a 0.5
              },
            }}
            // onClick={() => handleRiskLevelClick(level.value)}
          >
            {level.label}
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
};

export default RiskSelector;
